import React from "react";
import "./Our_team.css";
import { Container } from "react-bootstrap";
import Common_Title_2 from "../../common-components/common_title_2/Common_Title_2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserTie,
  faGraduationCap,
  faLightbulb,
  faBuilding,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";

function Our_team() {
  const director = {
    image: "/assets/images/about_us/director_img.jpeg",
    name: "Mr. Sopan Kale",
    qualification: "Founder & Director",
    role: "Seedso Agro",
    about: [
      {
        icon: faGraduationCap,
        text:
          "Seedso Agro is committed to empowering farmers through premium quality seeds, crop nutrition, and sustainable agricultural practices."
      },
      {
        icon: faLightbulb,
        text:
          "With years of agricultural experience, Mr. Sopan Kale has worked closely with farmers to improve productivity through innovative farming solutions."
      },
      {
        icon: faBuilding,
        text:
          "Under his leadership, Seedso Agro has built a strong reputation by delivering trusted products, expert guidance, and customer-focused services."
      },
      {
        icon: faUsers,
        text:
          "His vision is to make modern farming technologies accessible while helping farmers achieve better yields and long-term profitability."
      }
    ]
  };

  return (
    <section className="Our_team section_margin">
      <Container>

        <Common_Title_2 titleText="About Director" />

        <div className="director-card">

          <div className="director-left">

            <div className="director-image">
              <img src={director.image} alt={director.name} />
            </div>

            <h3>{director.name}</h3>

            <p className="qualification">
              {director.qualification}
            </p>

            <div className="line"></div>

            <h5>{director.role}</h5>

          </div>

          <div className="director-right">

            <h2>About Director</h2>

            <span className="subtitle">
              Empowering Agriculture Through Innovation
            </span>

            {director.about.map((item, index) => (
              <div className="about-item" key={index}>

                <div className="icon">
                  <FontAwesomeIcon icon={item.icon} />
                </div>

                <div className="text">
                  {item.text}
                </div>

              </div>
            ))}

          </div>

        </div>

      </Container>
    </section>
  );
}

export default Our_team;